<template>
  <div class="page-container">
    <div class="table-wrapper">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="入金通道配置" name="deposit"></el-tab-pane>
        <el-tab-pane label="出金通道配置" name="withdraw"></el-tab-pane>
      </el-tabs>

      <!-- 筛选查询区 -->
      <el-form :inline="true" :model="search" size="small" class="filter-bar" @submit.native.prevent>
        <el-form-item :label="isDeposit ? '支付方式' : '出金方式'">
          <el-select v-model="search.payMethod" placeholder="全部" clearable style="width:130px;">
            <el-option v-for="m in payMethods" :key="m" :label="m" :value="m"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户组别">
          <el-select v-model="search.customerGroupId" placeholder="全部" clearable style="width:130px;">
            <el-option v-for="g in groupOptions" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="search.isDelete" placeholder="全部" clearable style="width:120px;">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通道名称">
          <el-input v-model="search.channelName" placeholder="请输入通道名称" clearable style="width:150px;"></el-input>
        </el-form-item>
        <el-form-item label="结算币种">
          <el-select v-model="search.settlementCurrency" placeholder="全部" clearable style="width:140px;">
            <el-option v-for="c in currencies" :key="c" :label="c" :value="c"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属支付平台">
          <el-select v-model="search.payConfigId" placeholder="全部" clearable style="width:150px;">
            <el-option v-for="p in platformOptions" :key="p.id" :label="p.platformName" :value="p.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" style="width:260px;"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="table-header">
        <span class="table-title">{{ isDeposit ? '入金通道配置' : '出金通道配置' }}</span>
        <div class="table-actions">
          <el-button v-auth="'payment:payChannelConfig:save'" type="primary" size="small" icon="el-icon-plus" @click="openAdd">+ 新增{{ isDeposit ? '支付' : '出金' }}通道</el-button>
        </div>
      </div>

      <el-table :data="tableData" border v-loading="loading" style="width:100%;">
        <el-table-column prop="sort" label="排序" width="70" align="center">
          <template slot-scope="{row}">{{ row.sort }}</template>
        </el-table-column>
        <el-table-column prop="payConfigName" label="支付平台" min-width="110">
          <template slot-scope="{row}">{{ row.payConfigName || '--' }}</template>
        </el-table-column>
        <el-table-column :label="isDeposit ? '支付方式' : '出金方式'" width="100">
          <template slot-scope="{row}"><span class="badge">{{ row.payMethod }}</span></template>
        </el-table-column>
        <el-table-column prop="channelName" label="通道名称" min-width="120">
          <template slot-scope="{row}">{{ row.channelName }}</template>
        </el-table-column>
        <el-table-column :label="isDeposit ? '单笔入金最大金额' : '单笔出金最大金额'" width="135" align="right">
          <template slot-scope="{row}"><span class="mono">{{ fmtAmount(row.maxAmount) }}</span></template>
        </el-table-column>
        <el-table-column :label="isDeposit ? '单笔入金最小金额' : '单笔出金最小金额'" width="135" align="right">
          <template slot-scope="{row}"><span class="mono">{{ fmtAmount(row.minAmount) }}</span></template>
        </el-table-column>
        <el-table-column prop="settlementCurrency" label="结算币种" width="105"></el-table-column>
        <el-table-column label="客户组别" min-width="110">
          <template slot-scope="{row}">
            <template v-if="groupNames(row.customerGroups).length">
              <el-tooltip :content="groupNames(row.customerGroups).join('、')">
                <el-tag size="mini" type="info">{{ groupNames(row.customerGroups)[0] }}{{ groupNames(row.customerGroups).length > 1 ? ' +' + (groupNames(row.customerGroups).length - 1) : '' }}</el-tag>
              </el-tooltip>
            </template>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="createUser" label="创建人" width="90">
          <template slot-scope="{row}">{{ row.createUser || '--' }}</template>
        </el-table-column>
        <el-table-column prop="updateUser" label="最后更新人" width="100">
          <template slot-scope="{row}">{{ row.updateUser || '--' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="{row}">{{ fmtDateTime(row.createDate) }}</template>
        </el-table-column>
        <el-table-column label="最后更新时间" width="160">
          <template slot-scope="{row}">{{ fmtDateTime(row.updateDate) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="{row}">
            <el-switch v-auth="'payment:payChannelConfig:status'" v-model="row.isDelete" :active-value="1" :inactive-value="2" active-color="var(--brand-primary)" @change="toggleStatus(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right" align="center">
          <template slot-scope="{row}">
            <el-button v-auth="'payment:payChannelConfig:find'" type="text" size="small" style="color:var(--brand-primary);" @click="openDetail(row)">详情</el-button>
            <el-button v-auth="'payment:payChannelConfig:edit'" type="text" size="small" style="color:var(--brand-primary);" @click="openEdit(row)">编辑</el-button>
            <el-button v-auth="'payment:payChannelConfig:delete'" type="text" size="small" style="color:#dc2626;" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="(v)=>{pageSize=v;pageNum=1;fetchList()}" @current-change="(v)=>{pageNum=v;fetchList()}"
        :current-page="pageNum" :page-sizes="[15,30,50]" :page-size="pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :visible.sync="editVisible" width="860px" :close-on-click-modal="false" :title="(editForm.id ? '编辑' : '新增') + (isDeposit ? '支付' : '出金') + '通道'">
      <el-form :model="editForm" label-width="130px" size="small" :rules="editRules" ref="editForm">
        <el-tabs v-model="modalTab">
          <el-tab-pane label="基础配置" name="basic">
            <div class="form-section-title">① 支付平台</div>
            <div class="form-grid">
              <el-form-item label="支付平台" prop="payConfigId">
                <el-select v-model="editForm.payConfigId" style="width:100%;" placeholder="请选择支付平台">
                  <el-option v-for="p in platformOptions" :key="p.id" :label="p.platformName" :value="p.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="isDeposit ? '支付方式' : '出金方式'" prop="payMethod">
                <el-select v-model="editForm.payMethod" style="width:100%;" placeholder="请选择">
                  <el-option v-for="m in payMethods" :key="m" :label="m" :value="m"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结算币种" prop="settlementCurrency">
                <el-select v-model="editForm.settlementCurrency" style="width:100%;" placeholder="请选择结算币种">
                  <el-option v-for="c in currencies" :key="c" :label="c" :value="c"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="通道名称" prop="channelName">
                <el-input v-model="editForm.channelName" maxlength="100" show-word-limit placeholder="请输入通道名称"></el-input>
              </el-form-item>
              <el-form-item label="通道状态" prop="isDelete">
                <el-radio-group v-model="editForm.isDelete">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="2">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="通道排序" prop="sort">
                <el-input-number v-model="editForm.sort" :min="0" :precision="0" style="width:100%;"></el-input-number>
              </el-form-item>
            </div>
            <el-form-item label="通道图标" prop="iconUrl">
              <el-upload :action="uploadUrl" :headers="uploadHeaders" :show-file-list="false" :on-success="handleIconSuccess" accept="image/png,image/jpeg">
                <div v-if="editForm.iconUrl" class="icon-preview">
                  <img :src="editForm.iconUrl" alt="通道图标">
                  <i class="el-icon-circle-close icon-remove" @click="editForm.iconUrl=''"></i>
                </div>
                <el-button v-else size="small" icon="el-icon-upload">上传图标</el-button>
              </el-upload>
              <div class="form-hint">支持 jpg/png，建议 64x64，不超过 2MB</div>
            </el-form-item>
            <el-form-item label="客户组别" prop="customerGroups">
              <el-select v-model="editForm.customerGroups" multiple filterable clearable placeholder="请选择客户组别" style="width:100%;">
                <el-option v-for="g in groupOptions" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
              </el-select>
              <div class="form-hint">未选择客户组别表示全部客户可用</div>
            </el-form-item>
            <div class="form-section-title">② 金额与时间限制</div>
            <div class="form-grid">
              <el-form-item :label="isDeposit ? '入金金额模版' : '出金金额模版'" prop="payTemplatesId">
                <el-select v-model="editForm.payTemplatesId" style="width:100%;" placeholder="请选择金额模版" clearable>
                  <el-option v-for="t in templateOptions" :key="t.id" :label="t.templateName" :value="t.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="isDeposit ? '三方最低入金金额' : '三方最低出金金额'" prop="thirdMinAmount">
                <el-input-number v-model="editForm.thirdMinAmount" :min="0" :precision="2" :controls="false" style="width:100%;"></el-input-number>
              </el-form-item>
              <el-form-item :label="isDeposit ? '三方最高入金金额' : '三方最高出金金额'" prop="thirdMaxAmount">
                <el-input-number v-model="editForm.thirdMaxAmount" :min="0" :precision="2" :controls="false" style="width:100%;"></el-input-number>
              </el-form-item>
              <el-form-item :label="isDeposit ? '单笔入金最小金额' : '单笔出金最小金额'" prop="minAmount">
                <el-input-number v-model="editForm.minAmount" :min="0" :precision="2" :controls="false" style="width:100%;"></el-input-number>
              </el-form-item>
              <el-form-item :label="isDeposit ? '单笔入金最大金额' : '单笔出金最大金额'" prop="maxAmount">
                <el-input-number v-model="editForm.maxAmount" :min="0" :precision="2" :controls="false" style="width:100%;"></el-input-number>
              </el-form-item>
            </div>
          </el-tab-pane>
          <el-tab-pane label="手续费" name="fee">
            <div class="form-section-title">手续费模式</div>
            <el-form-item label="手续费方式" prop="feeMode">
              <el-radio-group v-model="editForm.feeMode" @change="handleFeeModeChange">
                <el-radio :label="1">按比例</el-radio>
                <el-radio :label="2">固定</el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-if="editForm.feeMode === 1">
              <div class="form-grid">
                <el-form-item label="手续费比例（%）" prop="feeRate">
                  <el-input-number v-model="editForm.feeRate" :min="0" :precision="4" :controls="false" style="width:100%;" placeholder="如 0.1"></el-input-number>
                </el-form-item>
                <el-form-item label="最低手续费" prop="minFee">
                  <el-input-number v-model="editForm.minFee" :min="0" :precision="2" :controls="false" style="width:100%;"></el-input-number>
                </el-form-item>
                <el-form-item label="最高手续费" prop="maxFee">
                  <el-input-number v-model="editForm.maxFee" :min="0" :precision="2" :controls="false" style="width:100%;"></el-input-number>
                </el-form-item>
              </div>
            </template>
            <template v-else>
              <el-form-item label="固定手续费" prop="fixedFee">
                <el-input-number v-model="editForm.fixedFee" :min="0" :precision="2" :controls="false" style="width:100%;"></el-input-number>
              </el-form-item>
            </template>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer">
        <el-button @click="editVisible=false">取消</el-button>
        <el-button type="primary" @click="submitSave">{{ editForm.id ? '保存' : '确定新增' }}</el-button>
      </div>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog :visible.sync="detailVisible" width="700px" :close-on-click-modal="false" :title="(detail && detail.channelType === 1 ? '入金' : '出金') + '通道详情'">
      <div v-if="detail" class="detail-body">
        <div class="detail-section">
          <div class="detail-title">基础信息</div>
          <div class="detail-grid">
            <div><span class="detail-label">支付平台：</span>{{ detail.payConfigName || '--' }}</div>
            <div><span class="detail-label">{{ isDeposit ? '支付方式' : '出金方式' }}：</span>{{ detail.payMethod || '--' }}</div>
            <div><span class="detail-label">通道名称：</span>{{ detail.channelName }}</div>
            <div><span class="detail-label">通道类型：</span>{{ detail.channelTypeName || '--' }}</div>
            <div><span class="detail-label">结算币种：</span>{{ detail.settlementCurrency || '--' }}</div>
            <div><span class="detail-label">排序：</span>{{ detail.sort }}</div>
            <div><span class="detail-label">状态：</span><span :style="{ color: detail.isDelete === 1 ? '#16a34a' : '#9ca3af' }">{{ detail.isDelete === 1 ? '启用' : '禁用' }}</span></div>
            <div><span class="detail-label">客户组别：</span>{{ groupNames(detail.customerGroups).join('、') || '全部客户' }}</div>
          </div>
        </div>
        <div class="detail-section">
          <div class="detail-title">金额配置</div>
          <div class="detail-grid">
            <div><span class="detail-label">金额模版：</span>{{ detail.payTemplatesName || '--' }}</div>
            <div><span class="detail-label">三方最低金额：</span>{{ fmtAmount(detail.thirdMinAmount) }}</div>
            <div><span class="detail-label">三方最高金额：</span>{{ fmtAmount(detail.thirdMaxAmount) }}</div>
            <div><span class="detail-label">单笔最小金额：</span>{{ fmtAmount(detail.minAmount) }}</div>
            <div><span class="detail-label">单笔最大金额：</span>{{ fmtAmount(detail.maxAmount) }}</div>
            <div><span class="detail-label">手续费方式：</span>{{ detail.feeModeName || '--' }}</div>
            <div v-if="detail.feeMode === 1">
              <span class="detail-label">手续费比例：</span>{{ detail.feeRate }}%（最低 {{ fmtAmount(detail.minFee) }}，最高 {{ fmtAmount(detail.maxFee) }}）
            </div>
            <div v-else><span class="detail-label">固定手续费：</span>{{ fmtAmount(detail.fixedFee) }}</div>
          </div>
        </div>
        <div class="detail-section">
          <div class="detail-title">审计信息</div>
          <div class="detail-grid">
            <div><span class="detail-label">创建人：</span>{{ detail.createUser || '--' }}</div>
            <div><span class="detail-label">最后更新人：</span>{{ detail.updateUser || '--' }}</div>
            <div><span class="detail-label">创建时间：</span>{{ fmtDateTime(detail.createDate) }}</div>
            <div><span class="detail-label">最后更新时间：</span>{{ fmtDateTime(detail.updateDate) }}</div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="detailVisible=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { payChannelConfigList, payChannelConfigAddOrUpdate, payChannelConfigDelete, payChannelConfigStatus } from '@/api/payChannelConfig'
import { payConfigList } from '@/api/payConfig'
import { paymentTemplatesConfigList } from '@/api/paymentTemplatesConfig'
import { customerGroupList } from '@/api/customerGroup'
import Url from '@/api/url'
import { localRead, getQueryString } from '@/utils/tools'
import { getToken } from '@/utils/auth'

export default {
  name: 'PayChannelConfigList',
  data() {
    return {
      activeTab: 'deposit',
      modalTab: 'basic',
      tableData: [], loading: false, total: 0,
      pageNum: 1, pageSize: 15,
      payMethods: ['USDT', 'USDT-Polygon', 'USDT-ERC20', 'USDT-BEP20', 'USDT-TRC20', 'Bank', 'AliPay', 'WeChat'],
      currencies: ['ZAR', 'USDT-TRC20', 'USDT-ERC20', 'USDT', 'CNY', 'IDR', 'USD', 'EUR', 'GBP'],
      platformOptions: [],
      groupOptions: [],
      templateOptions: [],
      search: {
        payMethod: '', customerGroupId: null, isDelete: null,
        channelName: '', settlementCurrency: '', payConfigId: null
      },
      dateRange: null,
      uploadUrl: Url.img.upload,
      uploadHeaders: {},
      editVisible: false,
      editForm: {},
      editRules: {
        payConfigId: [{ required: true, message: '请选择支付平台', trigger: 'change' }],
        payMethod: [{ required: true, message: '请选择支付/出金方式', trigger: 'change' }],
        settlementCurrency: [{ required: true, message: '请选择结算币种', trigger: 'change' }],
        channelName: [{ required: true, message: '请输入通道名称', trigger: 'blur' }],
        minAmount: [{ required: true, message: '请输入单笔最小金额', trigger: 'blur' }],
        maxAmount: [{ required: true, message: '请输入单笔最大金额', trigger: 'blur' }]
      },
      detailVisible: false,
      detail: null
    }
  },
  computed: {
    isDeposit() { return this.activeTab === 'deposit' }
  },
  created() {
    this.setUploadHeaders()
    this.fetchOptions()
    this.fetchList()
  },
  methods: {
    setUploadHeaders() {
      if (localRead('sysToken')) {
        this.uploadHeaders.Authorization = localRead('sysToken')
      } else if (window.SITE_CONFIG && window.SITE_CONFIG['routerLabel']) {
        this.uploadHeaders.Authorization = getToken(window.SITE_CONFIG['routerLabel'])
      } else if (window.location.href.indexOf('label') !== -1) {
        this.uploadHeaders.Authorization = getToken(getQueryString('label'))
      }
    },
    handleTabClick() {
      this.pageNum = 1
      this.resetSearch(false)
      this.fetchTemplates()
      this.fetchList()
    },
    fetchOptions() {
      payConfigList({ pageNum: 1, pageSize: 999 }).then(res => {
        if (res.code === 0) this.platformOptions = res.result.list || []
      })
      customerGroupList({ pageNum: 1, pageSize: 999 }).then(res => {
        if (res.code === 0) this.groupOptions = res.result.list || []
      })
      this.fetchTemplates()
    },
    fetchTemplates() {
      paymentTemplatesConfigList({ pageNum: 1, pageSize: 999, type: this.isDeposit ? 1 : 2, isDelete: 1 }).then(res => {
        if (res.code === 0) this.templateOptions = res.result.list || []
      })
    },
    fetchList() {
      this.loading = true
      const data = { pageNum: this.pageNum, pageSize: this.pageSize, channelType: this.isDeposit ? 1 : 2 }
      Object.keys(this.search).forEach(k => { if (this.search[k] !== '' && this.search[k] !== null && this.search[k] !== undefined) data[k] = this.search[k] })
      if (this.dateRange && this.dateRange.length === 2) {
        data.createDateStart = this.dateRange[0]
        data.createDateEnd = this.dateRange[1]
      }
      payChannelConfigList(data).then(res => {
        if (res.code === 0) { this.tableData = res.result.list || []; this.total = res.result.total || 0 }
        else this.$message.error(res.message || '查询失败')
      }).finally(() => { this.loading = false })
    },
    handleSearch() { this.pageNum = 1; this.fetchList() },
    resetSearch(reload = true) {
      this.search = {
        payMethod: '', customerGroupId: null, isDelete: null,
        channelName: '', settlementCurrency: '', payConfigId: null
      }
      this.dateRange = null
      if (reload) { this.pageNum = 1; this.fetchList() }
    },
    openAdd() {
      this.modalTab = 'basic'
      this.editForm = {
        id: null,
        channelType: this.isDeposit ? 1 : 2,
        payMethod: '', channelName: '', payConfigId: null, iconUrl: '',
        customerGroups: [], thirdMaxAmount: null, thirdMinAmount: null,
        maxAmount: null, minAmount: null, settlementCurrency: '',
        payTemplatesId: null, feeMode: 1, feeRate: null, minFee: null, maxFee: null, fixedFee: null,
        sort: 0, isDelete: 1
      }
      this.editVisible = true
    },
    openEdit(row) {
      this.modalTab = 'basic'
      this.editForm = {
        id: row.id,
        channelType: row.channelType,
        payMethod: row.payMethod, channelName: row.channelName,
        payConfigId: row.payConfigId, iconUrl: row.iconUrl || '',
        customerGroups: this.parseGroups(row.customerGroups),
        thirdMaxAmount: row.thirdMaxAmount == null ? null : Number(row.thirdMaxAmount),
        thirdMinAmount: row.thirdMinAmount == null ? null : Number(row.thirdMinAmount),
        maxAmount: row.maxAmount == null ? null : Number(row.maxAmount),
        minAmount: row.minAmount == null ? null : Number(row.minAmount),
        settlementCurrency: row.settlementCurrency || '',
        payTemplatesId: row.payTemplatesId, feeMode: row.feeMode || 1,
        feeRate: row.feeRate == null ? null : Number(row.feeRate),
        minFee: row.minFee == null ? null : Number(row.minFee),
        maxFee: row.maxFee == null ? null : Number(row.maxFee),
        fixedFee: row.fixedFee == null ? null : Number(row.fixedFee),
        sort: row.sort || 0, isDelete: row.isDelete
      }
      this.editVisible = true
    },
    openDetail(row) { this.detail = row; this.detailVisible = true },
    submitSave() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        const f = Object.assign({}, this.editForm)
        f.customerGroups = f.customerGroups && f.customerGroups.length ? JSON.stringify(f.customerGroups) : null
        payChannelConfigAddOrUpdate(f).then(res => {
          if (res.code === 0) {
            this.$message.success(f.id ? '保存成功' : '新增成功')
            this.editVisible = false
            this.fetchList()
          } else this.$message.error(res.message || '操作失败')
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除支付通道「' + row.channelName + '」？删除后不可恢复。', '删除确认', { type: 'warning' }).then(() => {
        payChannelConfigDelete(row.id).then(res => {
          if (res.code === 0) { this.$message.success('删除成功'); this.fetchList() }
          else this.$message.error(res.message || '操作失败')
        })
      }).catch(() => {})
    },
    toggleStatus(row) {
      payChannelConfigStatus(row.id, row.isDelete).then(res => {
        if (res.code === 0) {
          this.$message.success(row.isDelete === 1 ? '已启用' : '已禁用')
          this.fetchList()
        } else this.$message.error(res.message || '操作失败')
      })
    },
    handleFeeModeChange() {
      if (this.editForm.feeMode === 1) {
        this.editForm.fixedFee = null
      } else {
        this.editForm.feeRate = null
        this.editForm.minFee = null
        this.editForm.maxFee = null
      }
    },
    handleIconSuccess(response) {
      if (response.code === 0) { this.editForm.iconUrl = response.result; this.$message.success('图标上传成功') }
      else this.$message.error(response.message || '图标上传失败')
    },
    parseGroups(jsonStr) {
      if (!jsonStr) return []
      try {
        const arr = JSON.parse(jsonStr)
        return Array.isArray(arr) ? arr.map(Number) : []
      } catch (e) { return [] }
    },
    groupNames(jsonStr) {
      const ids = this.parseGroups(jsonStr)
      return ids.map(id => {
        const g = this.groupOptions.find(x => x.id === id)
        return g ? g.groupName : String(id)
      })
    },
    fmtAmount(v) {
      if (v === null || v === undefined || v === '') return '--'
      const n = Number(v)
      return isNaN(n) ? '--' : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    fmtDateTime(t) { return t ? String(t).replace('T', ' ').substring(0, 19) : '--' }
  }
}
</script>

<style scoped>
.page-container { background: #f4f6fb; min-height: calc(100vh - 84px); padding: 16px; }
.table-wrapper { background: #fff; border-radius: 10px; padding: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.04),0 4px 16px rgba(0,0,0,0.06); }
.filter-bar { margin-top: 4px; }
.table-header { display: flex; align-items: center; justify-content: space-between; margin: 12px 0; }
.table-title { font-size: 15px; font-weight: 600; color: #1a2236; }
.table-actions { display: flex; gap: 8px; align-items: center; }
.badge { display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 12px; color: var(--brand-primary); background: var(--brand-primary-a12); }
.mono { font-family: 'JetBrains Mono', monospace; font-size: 12px; }
.form-section-title { font-size: 14px; font-weight: 600; color: #1a2236; margin: 8px 0 12px; padding-bottom: 8px; border-bottom: 1px solid var(--brand-primary); }
.form-grid { display: grid; grid-template-columns: 1fr 1fr; column-gap: 20px; }
.form-hint { font-size: 12px; color: #9ca3af; margin-top: 4px; }
.icon-preview { position: relative; width: 64px; height: 64px; border-radius: 8px; overflow: hidden; border: 1px solid #e8ecf2; }
.icon-preview img { width: 100%; height: 100%; object-fit: cover; }
.icon-remove { position: absolute; top: -4px; right: -4px; font-size: 18px; color: #dc2626; cursor: pointer; background: #fff; border-radius: 50%; }
.detail-body { padding: 0 4px; }
.detail-section { margin-bottom: 20px; }
.detail-title { font-size: 14px; font-weight: 600; color: #1a2236; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid #e8ecf2; }
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 16px; font-size: 13px; }
.detail-label { color: #9ca3af; }
</style>
